import Holidays from "../_snowpack/pkg/date-holidays.js";
import * as React from "../_snowpack/pkg/react.js";
export const format = (date, format2, options) => {
  const context = React.useContext(DateHelperContext);
  return context.format(date, format2, options);
};
export const formatDuration = (value, options) => {
  const context = React.useContext(DateHelperContext);
  return context.formatDuration(value, options);
};
export function dayOfMonth(date) {
  return format(date, "d MMMM");
}
const hd = new Holidays({
  country: "PL"
});
export function getHoliday(date) {
  return hd.isHoliday(date);
}
export function isBankHoliday(date) {
  return getHoliday(date) !== false;
}
export const DateHelperContext = React.createContext(void 0);
